/* eslint-disable no-nested-ternary */
/* eslint-disable consistent-return */
/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable no-alert */
import { useCallback } from 'react'
import { useWeb3React, UnsupportedChainIdError } from '@web3-react/core'
import { NoBscProviderError } from '@binance-chain/bsc-connector'
import {
  NoEthereumProviderError,
  UserRejectedRequestError as UserRejectedRequestErrorInjected,
} from '@web3-react/injected-connector'
import {
  UserRejectedRequestError as UserRejectedRequestErrorWalletConnect,
  WalletConnectConnector,
} from '@web3-react/walletconnect-connector'
import { ConnectorNames, connectorLocalStorageKey } from '@pancakeswap/uikit'
import { connectorsByName } from 'utils/web3React'
import { setupNetwork } from 'utils/wallet'
import useToast from 'hooks/useToast'
import { useAppDispatch } from 'state'
import { useTranslation } from 'contexts/Localization'
import { connectWeb3 } from 'utils/connectWeb3'
import { toastTypes } from '@pixel-nft/uikit'

const chainId = process.env.REACT_APP_CHAIN_ID

const useAuth = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const { activate, deactivate } = useWeb3React()
  const { toastError } = useToast()
  const login = useCallback(
    (connectorID: ConnectorNames) => {
      const connector = connectorsByName[connectorID]
      if (connector) {
        activate(connector, async (error: Error) => {
          if (error instanceof UnsupportedChainIdError) {
            deactivate()
            const isConnect = await connectWeb3()
            if (!isConnect) {
              const text =
                +chainId === 97
                  ? 'BNB Smart Chain test'
                  : +chainId === 56
                  ? 'BNB Smart Chain'
                  : +chainId === 1
                  ? 'Ethereum'
                  : chainId
              toastError(`Please switch the straight chain manually: ${text}`)
            }
            activate(connector)
          } else {
            window.localStorage.removeItem(connectorLocalStorageKey)
            if (error instanceof NoEthereumProviderError || error instanceof NoBscProviderError) {
              // toastError(t('Provider Error'), t('No provider was found'))
              // 上线时修改swap 跳转metaMask浏览器 一起重新上线
              window.location.href = 'https://metamask.app.link/dapp/pixel.pixelfinance.io'
              // window.location.href='https://metamask.app.link/dapp'
            } else if (
              error instanceof UserRejectedRequestErrorInjected ||
              error instanceof UserRejectedRequestErrorWalletConnect
            ) {
              if (connector instanceof WalletConnectConnector) {
                const walletConnector = connector as WalletConnectConnector
                walletConnector.walletConnectProvider = null
              }
              toastError(t('Authorization Error'), t('Please authorize to access your account'))
            } else {
              toastError(error.name, error.message)
            }
          }
        })
      } else {
        toastError(t('Can’t find connector'), t('The connector config is wrong'))
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    },
    [activate, deactivate, t, toastError],
  )

  const logout = useCallback(() => {
    deactivate()
  }, [deactivate])

  return { login, logout }
}

export default useAuth
